import zod from 'zod';

export const TemperatureDetectorDeviceAvailableEvents = zod.enum([
  'FIREDETECTION',
  'FIREWARINING',
  'ANATOMY_TEMP_DETECT',
  'SMOKEDETECTION',
  'SMOKING_DETECT',
]);

export const TemperatureDetectorFormSchema = zod.object({
  availableEvents: zod.array(
    zod.enum([
      'FIREDETECTION',
      'FIREWARINING',
      'ANATOMY_TEMP_DETECT',
      'SMOKEDETECTION',
      'SMOKING_DETECT',
    ]),
  ),
});
// .merge(DeviceFormSchema);
